import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { SchoolCoursesService } from '@digilize/language-school/data';
import { SelectEntity } from '@digilize/language-school/ui';
import { MapService } from '@lsc/services/map.service';
import { first, Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'lsc-course-switcher',
  templateUrl: './course-switcher.component.html',
  styleUrls: ['./course-switcher.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class CourseSwitcherComponent implements OnInit, OnDestroy {
  constructor(
    private schoolCoursesService: SchoolCoursesService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private mapService: MapService
  ) {}
  coursesToSelect: SelectEntity[] = [];
  courseControl: FormControl<string>;
  _destroy = new Subject<boolean>();
  currentMap$ = this.mapService.currentMap$;

  ngOnInit() {
    this.initCourseControl();
  }

  initCourseControl() {
    this.schoolCoursesService.courses$.pipe(first()).subscribe((courses) => {
      this.coursesToSelect = courses.courses.map((course) => {
        return { label: course.display_name, value: course.id };
      });
    });
    this.courseControl = new FormControl(this.activatedRoute.snapshot.paramMap.get('course'));
    this.courseControl.valueChanges.pipe(takeUntil(this._destroy)).subscribe((value) => {
      this.router.navigate(['/course', value]);
    });
  }
  ngOnDestroy(): void {
    this._destroy.next(true);
  }
}
